'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagNcAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V6.66667H28V0Z", fill: "#094CC7" }),
      /* @__PURE__ */ jsx("path", { d: "M28 13.3333H0L0 20H28V13.3333Z", fill: "#2AAD55" }),
      /* @__PURE__ */ jsx("path", { d: "M28 6.66667H0L0 13.3333H28V6.66667Z", fill: "#F65D55" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14 14.6667C16.5773 14.6667 18.6667 12.5773 18.6667 10C18.6667 7.42267 16.5773 5.33333 14 5.33333C11.4227 5.33333 9.33333 7.42267 9.33333 10C9.33333 12.5773 11.4227 14.6667 14 14.6667Z",
          fill: "#FAE749"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.4556 8.28157C13.3786 8.39033 13.3333 8.52319 13.3333 8.66664C13.3333 9.03483 13.6317 9.3333 13.9999 9.3333C14.3681 9.3333 14.6666 9.03483 14.6666 8.66664C14.6666 8.34693 14.4415 8.07978 14.1412 8.01497C14.205 7.98247 14.2691 7.94768 14.3333 7.91065C15.1304 7.45042 15.6274 6.81883 15.4433 6.49997C15.2592 6.18111 14.4637 6.29571 13.6666 6.75595C12.8694 7.21619 12.3725 7.84777 12.5565 8.16664C12.6704 8.36387 13.0182 8.39525 13.4556 8.28157ZM13.9999 14C12.8954 14 12.6666 13.0348 12.6666 12.6666C12.6666 12.2984 12.8954 12 13.9999 12C15.1045 12 15.3333 12.2984 15.3333 12.6666C15.3333 13.0348 15.1045 14 13.9999 14ZM13.9999 12C13.6317 12 13.3333 11.7015 13.3333 11.3333C13.3333 10.9651 13.6317 10.6666 13.9999 10.6666C14.3681 10.6666 14.6666 10.9651 14.6666 11.3333C14.6666 11.7015 14.3681 12 13.9999 12ZM13.9999 10.6666C13.6317 10.6666 13.3333 10.3682 13.3333 9.99997C13.3333 9.63178 13.6317 9.3333 13.9999 9.3333C14.3681 9.3333 14.6666 9.63178 14.6666 9.99997C14.6666 10.3682 14.3681 10.6666 13.9999 10.6666Z",
          fill: "#262626"
        }
      )
    ]
  }
);
const VpFlagNcAsset = forwardRef(FlagNcAsset);

export { VpFlagNcAsset as default };
